export default "assets/images/icons/infowindow-marker-eda3699e.svg";